/* eslint-disable */
export const updateObject = (oldObject, updatedProperties) => ({
  ...oldObject,
  ...updatedProperties
});
